import React from 'react';
import { I18n } from 'js/components/common/I18n';
import { Icon } from 'js/components/common/Icon';
import { ConicDiagram } from '../ConicDiagram';
import cls from 'js/utils/classNameBuilder.util';
import { useFormatter } from 'js/hooks/useFormatter';
import { metricNumber } from 'js/utils/metricNumberFormatter.util';

import { formatCurrency } from '../helpers';

import style from './index.scss';

export default ({
    tt,
    classNames = {},

    currencyCode,
    timePeriod,
    remainingLimit,
    currentLimit,
    resetDate,
    newLimit,
    newLimitStartDate,

    unlimitedValue,
    precision = 2
}) => {
    const formatter = useFormatter();
    const currency = formatCurrency({ formatter, tt, currencyCode, precision, unlimitedValue });

    const isUnset = currentLimit == null || currentLimit === '';
    const isUnlimited = currentLimit === unlimitedValue;
    const isFinite = !isUnset && !isUnlimited;

    const [limitLeftPercent, limitLeftTitle] = isUnset
        ? [0, '']
        : isUnlimited
            ? [100, <Icon type="infinity" key={1} className={style.icon} />]
            : [remainingLimit / currentLimit * 100, metricNumber(remainingLimit)];

    const currentLimitTitle = tt(`current.${timePeriod}`, [currency(currentLimit)]);
    const currentLimitResetDateHint = tt('resetDate', [formatter.getDateTimeShort(resetDate)]);

    return (
        <>
            <ConicDiagram
                value={limitLeftPercent}
                title={limitLeftTitle}
                className={cls(['diagram'], style, classNames)}
            />

            <div className={cls(['currentLimit'], style, classNames)}>
                <div className={style.title}>{currentLimitTitle}</div>
                {isFinite && <div className={style.hint}>{currentLimitResetDateHint}</div>}
            </div>

            {newLimit != null && <>
                <div className={cls(['dash'], style, classNames)} />
                <I18n
                    className={cls(['newLimit'], style, classNames)}
                    tKey={'newLimitMessage'}
                    replacers={[currency(newLimit), formatter.getDateTimeShort(newLimitStartDate)]}
                    t={tt}
                />
            </>}
        </>
    );
};
